import React from "react";
import { createBrowserRouter, createRoutesFromElements, Navigate, Outlet, Route } from "react-router-dom";
import ContentLayout from "@webcore/layouts/ContentLayout.tsx";
import Homepage from "@/components/Homepage.tsx";
import Privacy from "@webcore/components/domain/content-site/pages/Privacy.tsx";
import TermsOfService from "@webcore/components/domain/content-site/pages/TermsOfService.tsx";
import TelemetryProvider from "@webcore/context-providers/TelemetryProvider.tsx";

function ContentMain() {
  return (
    <TelemetryProvider>
      <Outlet />
    </TelemetryProvider>
  );
}

const contentBrowserRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<ContentMain />}>
      <Route
        path=""
        element={
          <ContentLayout
            navLinks={[
              { label: "platform", to: "#platform" },
              { label: "workflows", to: "#workflows" },
              { label: "how it works", to: "#how-it-works" },
            ]}
            showSignInButtons={true}
            signUpEnabled={true}
          />
        }
      >
        <Route path="" element={<Homepage />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Route>,
  ),
);

export default contentBrowserRouter;
